import { Component, Host, h } from "@stencil/core";

/**
 * @slot [unnamed] - holds any number of HTML elements.
 */
@Component({
  tag: "eon-ui-form-grid-column",
  styleUrl: "form-grid-column.scss",
  shadow: false
})
export class FormGridColumn {
  render() {
    return <Host></Host>;
  }
}
